import React from 'react';
import FooterWrapper from '../components/FooterWrapper';

const CookieRichtlinie = () => {
  return (
    <div className="min-h-screen bg-black-pure flex flex-col overflow-hidden">
      
      <section className="relative z-10 bg-black-pure pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-geist text-white text-[24px] font-normal mb-8">COOKIE-RICHTLINIE</h1>
          
          <div className="space-y-8 font-geist">
            <div>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Diese Cookie-Richtlinie wurde zuletzt am September 01, 2025 aktualisiert und gilt für Bürger und Einwohner mit ständigem Wohnsitz im Europäischen Wirtschaftsraum und der Schweiz.
              </p>
              <div className="h-px bg-gray-800 my-6"></div>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">1. Einführung</h2>
              <p className="text-[#787c87] text-sm font-normal">
                Unsere Website, <a href="https://www.blcks.at" className="text-blue-400 hover:underline">https://www.blcks.at</a> (im folgenden: „Die Website“) verwendet Cookies und ähnliche Technologien (der Einfachheit halber werden all diese unter „Cookies“ zusammengefasst). Cookies werden außerdem von uns beauftragten Drittparteien platziert. In dem unten stehendem Dokument informieren wir dich über die Verwendung von Cookies auf unserer Website.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">2. Was sind Cookies?</h2>
              <p className="text-[#787c87] text-sm font-normal">
                Ein Cookie ist eine einfache kleine Datei, die gemeinsam mit den Seiten einer Internetadresse versendet und vom Webbrowser auf dem PC oder einem anderen Gerät gespeichert werden kann. Die darin gespeicherten Informationen können während folgender Besuche zu unseren oder den Servern relevanter Drittanbieter gesendet werden.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">3. Was sind Skripte?</h2>
              <p className="text-[#787c87] text-sm font-normal">
                Ein Script ist ein Stück Programmcode, das benutzt wird, um unserer Website Funktionalität und Interaktivität zu ermöglichen. Dieser Code wird auf unseren Servern oder auf deinem Gerät ausgeführt.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">4. Was ist ein Web Beacon?</h2>
              <p className="text-[#787c87] text-sm font-normal">
                Ein Web-Beacon (auch Pixel-Tag genannt), ist ein kleines unsichtbares Textfragment oder Bild auf einer Website, das benutzt wird, um den Verkehr auf der Website zu überwachen. Um dies zu ermöglichen werden diverse Daten von dir mittels Web-Beacons gespeichert.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">5. Cookies</h2>
              <h3 className="text-white text-base font-normal mb-2">5.1 Technische oder funktionelle Cookies</h3>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Einige Cookies stellen sicher, dass Teile unserer Website richtig funktionieren und deine Nutzervorlieben bekannt bleiben. Durch das Platzieren funktionaler Cookies machen wir es dir einfacher unsere Website zu besuchen. Auf diese Weise musst du bei Besuchen unserer Website nicht wiederholt die gleichen Informationen eingeben, oder deine Gegenstände bleiben beispielsweise in deinem Warenkorb bis du bezahlst. Wir können diese Cookies ohne dein Einverständnis platzieren.
              </p>
              
              <h3 className="text-white text-base font-normal mb-2">5.2 Analytische Cookies</h3>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Wir verwenden analytische Cookies, um das Website-Erlebnis für unsere Nutzer zu optimieren. Mit diesen analytischen Cookies erhalten wir Einblicke in die Nutzung unserer Website. Wir bitten um deine Erlaubnis, analytische Cookies zu setzen.
              </p>
              
              <h3 className="text-white text-base font-normal mb-2">5.3 Marketing- / Tracking-Cookies</h3>
              <p className="text-[#787c87] text-sm font-normal">
                Marketing- / Tracking-Cookies sind Cookies oder eine andere Form der lokalen Speicherung, die zur Erstellung von Benutzerprofilen verwendet werden, um Werbung anzuzeigen oder den Benutzer auf dieser Website oder über mehrere Websites hinweg für ähnliche Marketingzwecke zu verfolgen.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">6. Zustimmung</h2>
              <p className="text-[#787c87] text-sm font-normal">
                Wenn du unsere Website das erste Mal besuchst, zeigen wir dir ein Pop-Up mit einer Erklärung über Cookies. Sobald du auf „Einstellungen speichern“ klickst, gibst du uns dein Einverständnis, alle von dir gewählten Kategorien von Cookies und Plugins wie in dieser Cookie-Erklärung beschrieben zu verwenden. Du kannst die Verwendung von Cookies über deinen Browser deaktivieren, aber bitte beachte, dass unsere Website dann unter Umständen nicht richtig funktioniert.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">7. Aktivierung / Deaktivierung und Löschen von Cookies</h2>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Du kannst deinen Internetbrowser verwenden um automatisch oder manuell Cookies zu löschen. Du kannst außerdem spezifizieren ob spezielle Cookies nicht platziert werden sollen. Eine andere Möglichkeit ist es deinen Internetbrowser derart einzurichten, dass du jedes Mal benachrichtigt wirst, wenn ein Cookie platziert wird. Für weitere Information über diese Möglichkeiten beachte die Anweisungen in der Hilfesektion deines Browsers.
              </p>
              <p className="text-[#787c87] text-sm font-normal">
                Bitte beachten Sie, dass unsere Website möglicherweise nicht richtig funktioniert, wenn alle Cookies deaktiviert sind. Wenn Sie die Cookies in Ihrem Browser löschen, werden sie nach Ihrer Zustimmung erneut gesetzt, wenn Sie unsere Website erneut besuchen.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">8. Deine Rechte in Bezug auf persönliche Daten</h2>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                <strong>Du hast in Bezug auf deine persönlichen Daten die folgenden Rechte:</strong>
              </p>
              <ul className="list-disc pl-5 space-y-2 text-[#787c87] text-sm font-normal mb-4">
                <li>Du hast das Recht zu wissen, warum deine persönlichen Daten gebraucht werden, was mit ihnen passiert und wie lange diese verwahrt werden.</li>
                <li>Zugriffsrecht: Du hast das Recht deine uns bekannten persönliche Daten einzusehen.</li>
                <li>Recht auf Berichtigung: Du hast das Recht wann immer du wünschst, deine persönlichen Daten zu ergänzen, zu korrigieren sowie gelöscht oder blockiert zu bekommen.</li>
                <li>Wenn du uns dein Einverständnis zur Verarbeitung deiner Daten gegeben hast, hast du das Recht dieses Einverständnis zu widerrufen und deine persönlichen Daten löschen zu lassen.</li>
                <li>Recht auf Datentransfer deiner Daten: Du hast das Recht, alle deine persönlichen Daten von einem Kontrolleur anzufordern und in ihrer Gesamtheit zu einem anderen Kontrolleur zu transferieren.</li>
                <li>Widerspruchsrecht: Du kannst der Verarbeitung deiner Daten widersprechen. Wir entsprechen dem, es sei denn es gibt berechtigte Gründe für die Verarbeitung.</li>
              </ul>
              <p className="text-[#787c87] text-sm font-normal">
                Um diese Rechte auszuüben kontaktiere uns bitte. Bitte beziehe dich auf die Kontaktdaten am Ende dieser Cookie-Erklärung. Wenn du eine Beschwerde darüber hast, wie wir deine Daten behandeln, würden wir diese gerne hören, aber du hast auch das Recht diese an die Aufsichtsbehörde (der Datenschutzbehörde) zu richten.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">9. Kontaktdaten</h2>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Für Fragen und/oder Kommentare über unsere Cookie-Richtlinien und diese Aussage kontaktiere uns bitte mittels der folgenden Kontaktdaten:
              </p>
              <p className="text-[#787c87] text-sm font-normal">BLCKs e.U.</p>
              <p className="text-[#787c87] text-sm font-normal">Philipp Fuchs</p>
              <p className="text-[#787c87] text-sm font-normal">Heinrich-Casper-Gasse 29/9</p>
              <p className="text-[#787c87] text-sm font-normal">8010 Graz</p>
              <p className="text-[#787c87] text-sm font-normal">Österreich</p>
              <p className="text-[#787c87] text-sm font-normal">Website: <a href="https://www.blcks.at" className="text-blue-400 hover:underline">https://www.blcks.at</a></p>
              <p className="text-[#787c87] text-sm font-normal">E-Mail: <a href="mailto:hello@blcks.at" className="text-blue-400 hover:underline">hello@blcks.at</a></p>
            </div>
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default CookieRichtlinie;
